const SET_DEVICE_NAME = (state, token) => {
  state.deviceName = token;
};

const SET_DEVICE_TOKEN = (state, token) => {
  state.deviceToken = token;
};

const DESTROY_DEVICE = (state) => {
  state.deviceName = '';
  state.deviceToken = '';
};

export default {
  SET_DEVICE_NAME,
  SET_DEVICE_TOKEN,
  DESTROY_DEVICE
};



// WEBPACK FOOTER //
// ./src/store/modules/device/mutations.js